'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _help = require('./help');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//import {helpDetailComponent}  from './detail';  
//import {helpContactComponent}  from './components/help-contact';
//import {helpContactBoxComponent}  from './components/help-contact-box';
//import {helpContactFaqBoxComponent}  from './components/help-contact-faq-box';

var _module = _angular2.default.module('app.help', []).config(["$stateProvider", function ($stateProvider) {
    'ngInject';

    $stateProvider.state('help', {
        parent: 'general',
        url: '/help/{questionCode}',
        views: {
            'main@root': {
                component: 'help'
            }
        },
        resolve: {
            helpCategories: ["helpService", function helpCategories(helpService) {
                return helpService.getHelpCategories();
            }]
        },
        ncyBreadcrumb: {
            label: '{{"FAQ" | translate}}'
        }
    }); /*
        .state('helpDetail', {
        parent: 'help',
        url: '/{categoryId}/{subCategoryId}/{questionId}',
        views:{
            'main@root':{
                component: 'helpDetail'
            }
        },
        reloadOnSearch : false,
        resolve: { 
            helpCategory: function($stateParams, helpService) {
                debugger;
                return helpService.getHelpSubCategory($stateParams.categoryId);
            }
        }
        });*/
}]).component('help', _help.helpComponent);
//.component('helpDetail', helpDetailComponent);
//.component('helpContact', helpContactComponent)
//.component('helpContactBox', helpContactBoxComponent)
//.component('helpContactFaqBox', helpContactFaqBoxComponent);

exports.default = _module.name;


//////////////////
// WEBPACK FOOTER
// ./features/help/index.js
// module id = 935
// module chunks = 0